module.exports = __webpack_public_path__ + "img/right.9b865556.png";